import React, { useEffect, useState, useCallback } from 'react';
import { Button, Layout, Modal, Spin, Tree, message } from 'antd';
import { getIndicadoresDetalle } from '../../services/IndicadoresService';
import TableDetalle from './detalle';
import { getmunicipios } from '../../services/municipios';
import './modal.css';
import logoGobernacion from './../../assets/img/logoGobernacion.png';
import logoTangara from './../../assets/img/logoTangara.png';

const ModalResultados = ({ Idindicador, indicador, width }) => {
  const [isModalOpen, setIsModalOpen] = useState(false);
  const [data, setData] = useState(null);  // Inicializamos en null
  const [loading, setLoading] = useState(false);
  const [treeData, setTreeData] = useState([]);
  const [selectedMunicipios, setSelectedMunicipios] = useState([]);
  const [isTreeHidden, setIsTreeHidden] = useState(false);
  const [isTreeVisible, setIsTreeVisible] = useState(true); // Estado para controlar la visibilidad del árbol
  const { Header, Content, Sider } = Layout;

  // Función para mostrar el modal y cargar los municipios
  const showModal = async () => {
    setIsModalOpen(true);
    setLoading(true);
    try {
      const response = await getmunicipios(Idindicador);
      if (response.status === 200 && response.data.detalleIndicador) {
        const { municipios } = response.data.detalleIndicador;
        const treeMunicipios = municipios.map((municipio) => ({
          title: municipio.nombreMunicipio,
          key: municipio.idMunicipio,
        })).sort((a, b) => a.title.localeCompare(b.title));
        setTreeData(treeMunicipios);
      } else {
        message.error('Error en la respuesta del servidor.');
      }
    } catch (error) {
      message.error('Error al obtener los datos del indicador.');
    } finally {
      setLoading(false);
    }
  };

  // Función para manejar el filtrado y enviar los datos al backend
  const handleFiltrar = useCallback(async () => {
    if (selectedMunicipios.length === 0) {
      message.warning('Debe seleccionar al menos un municipio.');
      return;
    }

    setLoading(true);
    try {
      const response = await getIndicadoresDetalle(Idindicador, selectedMunicipios);

      if (response.status === 200 && response.data.length > 0) {
        const { desagregaciones } = response.data[0];

        const formattedData = desagregaciones.flatMap((desagregacion) =>
          desagregacion.resultados.map((resultado) => ({
            key: resultado.iddetalleresultado,
            desagregacion: desagregacion.desagregaciontematica,
            idDesagregacion: desagregacion.iddesagregacion,
            nombreIndicador: response.data[0].nombreindicador,
            municipio: resultado.municipio,
            idmunicipio: resultado.idmunicipio,
            periodo: resultado.periodo,
            idperiodicidad: resultado.idperiodicidad,
            valorPeriocidad: resultado.valorperiocidad,
            resultado: resultado.resultado,
            subregion: resultado.subregion || '',
            clasificacion: resultado.clasificacion,
            idclasificacion: resultado.idclasificacion,
            tipoResultado: resultado.tipoResultado || resultado.tipoResultado
          }))
        );
        setData(formattedData);
        setIsTreeHidden(true);
      } else {
        // Si no hay datos, mostramos una tabla vacía
        const municipiosConNombre = selectedMunicipios.map(id => {
          const municipio = treeData.find(m => m.key === id);
          return {
            municipio: municipio ? municipio.title : `ID ${id}`, // Muestra el nombre si existe, de lo contrario muestra el ID
            idmunicipio: id,
            resultados: []
          };
        });
        setData(municipiosConNombre);

      }
    } catch (error) {
      console.error('Error al filtrar los datos:', error);
      message.error('Error al filtrar los datos.');
    } finally {
      setLoading(false);
    }
  }, [Idindicador, selectedMunicipios, treeData]);

  const handleCancel = () => {
    setIsModalOpen(false);
    setIsTreeHidden(false);
  };

  const toggleTree = () => {
    setIsTreeVisible(prev => !prev);
    setIsTreeHidden(prev => !prev); // Cambia el estado del árbol
  };

  const handleSelectMunicipio = (selectedKeys) => {
    setSelectedMunicipios(selectedKeys);
  };

  useEffect(() => {
    if (selectedMunicipios.length > 0) {
      handleFiltrar();
    }
  }, [selectedMunicipios, handleFiltrar]);

  return (
    <>
      <Button type="primary" onClick={showModal}>
        Editar
      </Button>

      <Modal
        width="90%"
        open={isModalOpen}
        onOk={handleCancel}
        onCancel={handleCancel}
        footer={null}
        style={{ top: '10px', height: 'auto', overflow: 'hidden', marginBottom: '10px' }}

      >
        <Layout>
          <Header >
            <div className="headerLine"></div>
            <div className="detalle row">
              <div className="detalleIndicador col-md-6">
                <li>{indicador.area}</li>
                <li>{indicador.tema}</li>
                <li>{indicador.indicador}</li>
              </div>
              <div className="logos col-md-6 d-flex justify-content-center align-items-center" style={{ overflow: 'hidden' }}>
                <img
                  src={logoGobernacion}
                  alt="Logo Gobernación"
                  style={{
                    flex: 6,
                    maxWidth: '51%',
                    maxHeight: '100%',
                    objectFit: 'contain',
                  }}
                />
                <img
                  src={logoTangara}
                  alt="Logo Tángara"
                  style={{
                    flex: 4,
                    maxWidth: '32%',
                    maxHeight: '100%',
                    objectFit: 'contain',
                  }}
                />
              </div>

            </div>
          </Header>
        </Layout>

        <Layout>
          <Sider
            className={`modaltree ${isTreeHidden ? 'modaltree-hidden' : ''}`}
            style={{ maxHeight: '70vh', overflowY: 'auto', width: '300px' }}
          >
            <h3 className="ubicacion">Ubicación</h3>
            <Tree
              onSelect={handleSelectMunicipio}
              selectedKeys={selectedMunicipios}
              treeData={treeData}
              defaultExpandAll
              className="municipio-tree"
            />
          </Sider>

          <Content>
            <div className="modalContent">
              {loading ? (
                <Spin />
              ) : (
                <div className="contene">
                  <div className="button-container">
                    <button className={`toggle-tree-btn ${isTreeVisible ? '' : 'rotated'}`} onClick={toggleTree}></button>
                  </div>
                  {data ? (
                    <div className="custom-table-wrapper">
                      <TableDetalle data={data} idIndicador={Idindicador} onUpdate={setData} onReload={handleFiltrar} />
                    </div>
                  ) : (
                    <div className="empty-message"><h1>Seleccione una ubicación</h1></div>
                  )}
                </div>
              )}
            </div>
          </Content>
        </Layout>
      </Modal >
    </>
  );
}

export default ModalResultados;
